import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import somasLogo from '../../../assets/images/somas-logo.png'
import { slugify } from '../../../utils/slugify'
import './Navbar.scss'

const ArrowDown = () => (
  <svg width="16" height="9" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: 4, verticalAlign: 'middle' }}>
    <path d="M1 1L11 11L21 1" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const aboutSubmenu = [
  <Link to={'/sobre-nos'} style={{ color: 'white' }}>Quem somos</Link>,
  <a href="https://mastertech-tech.typeform.com/to/tjryMzty" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>Quero ser voluntário</a>,
  <a href="https://mastertech-tech.typeform.com/to/tjryMzty" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>Trabalhe conosco</a>,
]

const Navbar = () => {
  const [aboutOpen, setAboutOpen] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [projectsOpen, setProjectsOpen] = useState(false)
  const [projectsSubmenu, setProjectsSubmenu] = useState([])

  useEffect(() => {
    fetch('/projects.json')
      .then(res => res.json())
      .then(data => {
        setProjectsSubmenu(data.map(project => ({
          name: project.title,
          slug: slugify(project.title)
        })))
      })
  }, [])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900 && mobileMenuOpen) setMobileMenuOpen(false)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [mobileMenuOpen])

  useEffect(() => {
    if (!mobileMenuOpen) return
    const handleClick = (e) => {
      if (!e.target.closest('.navbar')) setMobileMenuOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [mobileMenuOpen])

  return (
    <nav className="navbar">
      <div className="navbar__logo">
        <Link to="/">
          <img src={somasLogo} alt="Somas Logo" />
        </Link>
      </div>
      <button
        className={`navbar__hamburger${mobileMenuOpen ? ' open' : ''}`}
        aria-label="Abrir menu"
        aria-expanded={mobileMenuOpen}
        onClick={() => setMobileMenuOpen((open) => !open)}
      >
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </button>
      <ul className={`navbar__menu${mobileMenuOpen ? ' open' : ''}`}>
        <li
          className={`dropdown${aboutOpen ? ' open' : ''}`}
          tabIndex={0}
          onMouseEnter={() => setAboutOpen(true)}
          onMouseLeave={() => setAboutOpen(false)}
        >
          SOBRE NÓS <ArrowDown />
          <ul className={`submenu${aboutOpen ? ' open' : ''}`}>
            {aboutSubmenu.map((item, idx) => (
              <li key={idx} onClick={() => setMobileMenuOpen(false)}>{item}</li>
            ))}
          </ul>
        </li>
        <li
          className={`dropdown${projectsOpen ? ' open' : ''}`}
          tabIndex={0}
          onMouseEnter={() => setProjectsOpen(true)}
          onMouseLeave={() => setProjectsOpen(false)}
        >
          PROJETOS <ArrowDown />
          <ul className={`submenu${projectsOpen ? ' open' : ''}`}>
            {projectsSubmenu.map((item, idx) => (
              <li key={idx} style={{ padding: 0, margin: 0 }} onClick={() => setMobileMenuOpen(false)}>
                <Link to={`/projeto/${item.slug}`} style={{ display: 'block', width: '100%', height: '100%', padding: '12px 24px', color: 'inherit', textDecoration: 'none' }}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </li>
        <li onClick={() => setMobileMenuOpen(false)}><Link to="/parcerias">PARCERIAS</Link></li>
        <li onClick={() => setMobileMenuOpen(false)}><Link to="/parcerias">CONTATO</Link></li>
      </ul>
      {mobileMenuOpen && (
        <div className="navbar__donate-mobile">
          <a
            className="donate-btn"
            href="https://mastertech-tech.typeform.com/to/tjryMzty"
            target="_blank"
            rel="noopener noreferrer"
          >
            QUERO DOAR
          </a>
        </div>
      )}
      <div className="navbar__actions">
        <a
          className="donate-btn"
          href="https://mastertech-tech.typeform.com/to/tjryMzty"
          target="_blank"
          rel="noopener noreferrer"
        >
          QUERO DOAR
        </a>
      </div>
    </nav>
  )
}

export default Navbar
